import React from 'react'

const Fot = () => {
    return (
        <div className='container'>
            <div className=' d-flex justify-content-center'>
                © 2022 by Zulfikar Aji
            </div>
        </div>
    )
}

export default Fot
